import { BaseDataItem, Component, RefSchemas } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

type DataRefsSchema = { [key: string]: DataRefsSchema | true }
type Refs = undefined | { [key: string]: Refs }
const assignDeep = (item: object, refs: Refs, schema: DataRefsSchema) => {
	const viewItem: Record<string, any> = { ...item }
	if (!refs || !schema) {
		return viewItem
	}
	for (const ref in schema) {
		const refSchema = schema[ref]
		if (ref in viewItem && ref in refs) {
			const refValue = refs[ref]
			if (refSchema === true) {
				// actual ref
				viewItem[ref] = refValue
			} else {
				// ancestor of referred data (e.g. ref='a', refValue={b: 'value'} , when ref path is ['a', 'b']
				// assign the refValue to the viewItem, while keeping the rest of a's properties in the dataItem
				viewItem[ref] = assignDeep(viewItem[ref], refValue, refSchema)
			}
		}
	}
	return viewItem
}

export const defaultToViewItem = (refData: RefSchemas) => {
	const refsSchema: any = {}

	const getRefSchema = (mapName: string, type: string) => {
		if (refsSchema[mapName]?.[type]) {
			return refsSchema[mapName][type]
		}

		const mapKey = `${mapName}.json`
		if (!refData[mapKey]?.[type]) {
			return null
		}

		const refs = refData[mapKey][type].reduce((acc, { path }) => {
			_.set(acc, path, true)
			return acc
		}, {})

		refsSchema[mapName] = refsSchema[mapName] || {}
		refsSchema[mapName][type] = refs
		return refs
	}

	return <T extends BaseDataItem>(mapName: string, dataItem: T, refs: Refs) => {
		const schema = getRefSchema(mapName, dataItem.type)

		const viewItem = assignDeep(dataItem, refs, schema)
		delete viewItem.metaData
		return viewItem
	}
}

export const oldDefaultToViewItem = <T extends BaseDataItem>(_mapName: string, rawItem: T, refs: any) => {
	const result = { ...rawItem, ...refs }
	delete result.metaData
	return result
}
const COMPONENT_TYPE_MAPPING: Record<string, string> = {
	AppPage: 'Page',
	BoxSlideShow: 'SlideShowContainer',
	BoxSlideShowSlide: 'SlideShowSlide',
	InlinePopup: 'MenuContainer',
	InlinePopupToggle: 'MenuToggle',
	MobileMerge: 'DivWithChildren',
	OldBlogDeprecation: 'Container',
	PopupCloseTextButton: 'SiteButton',
	SiteRegionContainer: 'Container',
	SlideshowItem: 'Container',
	StateBoxFormState: 'SlideShowSlide',
	StateBoxState: 'SlideShowSlide',
	StripContainerSlideShow: 'SlideShowContainer',
	StripContainerSlideShowSlide: 'SlideShowSlide',
	TwitterFeed: 'DivWithChildren',
	WGooglePlusOne: 'DivWithChildren',
}

const mapComponentType = (componentType: string): string => COMPONENT_TYPE_MAPPING[componentType] || componentType

export const fixStructure = (component: Component): Component => {
	const { componentType, skin } = component
	const fixedComponent = { ...component, componentType: mapComponentType(_.last(componentType.split('.'))!) }
	if (skin) {
		fixedComponent.skin = skin.startsWith('svgshape.') ? skin : _.last(skin.split('.'))!
	}
	return fixedComponent
}
